import { render, staticRenderFns } from "./Остатки по дням.vue?vue&type=template&id=dcce84d2&scoped=true&"
import script from "./Остатки по дням.vue?vue&type=script&lang=js&"
export * from "./Остатки по дням.vue?vue&type=script&lang=js&"
import style0 from "./Остатки по дням.vue?vue&type=style&index=0&id=dcce84d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcce84d2",
  null
  
)

export default component.exports